import type { PageUpdate } from "./page-updates";

export type ExamplePostComment = {
  id: string;
  author: string | null;
  body: string;
  when: string;
  reply?: true;
};

/** Fictional conversation only: real feeds never acquire synthetic comments or engagement. */
export function examplePostComments(item: Pick<PageUpdate, "example" | "locked">) {
  if (!item.example) return null;
  if (item.locked) return { count: null, items: [] };
  const comments: ExamplePostComment[] = [
    {
      id: "maya",
      author: "Maya Chen",
      body: "These little behind-the-scenes moments are my favourite. Thanks for sharing them with us!",
      when: "2 hours ago",
    },
    {
      id: "creator",
      author: null,
      body: "Thank you for being here! I love having a place to share the little things, too.",
      when: "1 hour ago",
      reply: true,
    },
    {
      id: "jordan",
      author: "Jordan Lee",
      body: "Such a lovely update. Looking forward to the next one.",
      when: "45 minutes ago",
    },
  ];
  return { count: comments.length, items: comments };
}

/**
 * Fictional counts for an example's social card, steady for each example. Its comment count
 * matches the thread its post page shows; a real post's counts load after the page does.
 */
export function examplePostEngagement(item: Pick<PageUpdate, "example" | "id" | "locked">) {
  if (!item.example) return null;
  const seed = [...item.id].reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return {
    likes: 8 + ((seed * 7) % 41),
    comments: examplePostComments(item)?.count ?? 2 + (seed % 5),
  };
}
